import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { SignupFormData, MailMagazineState } from '@/types/signup'

interface SignupState {
  formData: SignupFormData
  mailMagazine: MailMagazineState
  isSubmitting: boolean
  error: string | null
}

const initialState: SignupState = {
  formData: {
    familyName: null,
    firstName: null,
    familyNameKana: null,
    firstNameKana: null,
    password: '',
    confirmPassword: '',
    gender: null,
    birthday: null,
    job: '',
    purpose: '',
    publishedNotice: true,
    agreement: false,
  },
  mailMagazine: {
    isStudentChecked: true,
    isJobseekerChecked: true,
  },
  isSubmitting: false,
  error: null,
}

const signupSlice = createSlice({
  name: 'signup',
  initialState,
  reducers: {
    updateFormData: (state, action: PayloadAction<Partial<SignupFormData>>) => {
      state.formData = { ...state.formData, ...action.payload }
    },
    updateMailMagazine: (state, action: PayloadAction<Partial<MailMagazineState>>) => {
      state.mailMagazine = { ...state.mailMagazine, ...action.payload }
    },
    setSubmitting: (state, action: PayloadAction<boolean>) => {
      state.isSubmitting = action.payload
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
    },
    resetForm: (state) => {
      state.formData = initialState.formData
      state.mailMagazine = initialState.mailMagazine
      state.error = null
    },
  },
})

export const { updateFormData, updateMailMagazine, setSubmitting, setError, resetForm } =
  signupSlice.actions

export default signupSlice.reducer
